import { useEffect, useState } from "react";
import { useToastContext } from "../../../../../contexts/ToastContext/ToastContext";

import Web3 from "web3";
import { ABI } from "../ABI";


const ethers = require('ethers')
const web3 = new Web3("https://bsc-dataseed.binance.org/");
const EXC_ADDRESS = "0x894A56C1276e885ebB369b99E3d154512b4c682c";
let provider = null
if (window.ethereum) {
  provider = new ethers.BrowserProvider(window.ethereum)
}
const Web3Services = () => {
  const [walletAddress, setWalletAddress] = useState(null)
  const [cryptoBalance, setCryptoBalance] = useState(null)
  const [isLogged, setIsLogged] = useState(false)
  const { showErrorToast, showSuccessToast } = useToastContext();


  const getUserBalance = async (account) => {
    const signer = await provider.getSigner();
    const EXC = new ethers.Contract(EXC_ADDRESS, ABI, signer);
    const balance = (await EXC.balanceOf(account))
    setCryptoBalance(ethers.formatEther(balance))
  }

  const updateAccount = (account) => {
    setWalletAddress(account)
    getUserBalance(account)
  }

  const connectWallet = async () => {
    if (!window.ethereum) {
      showErrorToast({
        detail: "MetaMask not installed",
      });
      return
    }
    let res = await window.ethereum.request({ method: 'eth_requestAccounts' })
    if (res.length > 0) {
      setIsLogged(true)
    } else {
      setIsLogged(false)
    }
    updateAccount(res[0])
  }

  const convertToExc = (amount, currency) => {
    amount = amount * 100000
    let currencyMUltiplier = {
      'BRL': 10,
      'USD': 50,
      'EUR': 60,
      'EXC': 1
    }
    amount = amount * currencyMUltiplier[currency]
    if (!currencyMUltiplier[currency]) {
      throw new Error("Moeda inválida")
    }
    return amount / 100000
  }

  const sendTransaction = async (value, currency, toAddress) => {
    let amount = convertToExc(value, currency)
    const signer = await provider.getSigner();
    const EXC = new ethers.Contract(EXC_ADDRESS, ABI, signer);
    amount = ethers.parseUnits(String(amount), 18);

    let res = await EXC.transfer(toAddress,amount)
    res = await res.wait()
    console.log(res)
    return res.hash
  }
  return {
    connectWallet,
    sendTransaction,
    cryptoBalance,
    walletAddress,
    isLogged
  }
}
export default Web3Services
